import React, { useEffect, useState } from 'react';
import { Client } from '@twilio/conversations';
import Cookies from 'js-cookie';
import { ProjectIcon } from '@gtintel/platform-atoms';
import { ChatButton } from '@gtintel/platform-chat';
import { TWILIO_ADMIN_IDENTITY } from '@gtintel/platform-constants';
import { UseChatContext } from '@gtintel/platform-context';
import { Container } from './styles';
const AssignmentButton = ({
  onConnect,
  project,
  user
}) => {
  const [twilioClient, setTwilioClient] = useState(null);
  const [conversationData, setConversationData] = useState(() => {
    const conversationData = {};
    for (const ac of project.assignment_chats) {
      const sid = ac.twilio_conversation_sid;
      conversationData[sid] = {
        isAdminPartnerChannel: true,
        channelName: sid,
        channelId: '',
        channel: null,
        isInitializationFailed: false,
        isInitializing: false,
        unreadMessageCount: 0
      };
    }
    return conversationData;
  });
  const {
    createChatDetailRegister,
    verifyIfChatIsOpen
  } = UseChatContext();
  const setChannelData = (channelName, key, value) => {
    setConversationData(cd => {
      const channelState = {
        ...cd[channelName]
      };
      channelState[key] = value;
      return {
        ...cd,
        [channelName]: channelState
      };
    });
  };

  // setChannelData can't be used to increment UMC because when you increment,
  // the new state depends on the previous state, which prevents setChannelData
  // from working due to the way React state updates work.
  const incrementUnreadMessageCount = channelName => {
    setConversationData(cd => {
      const channelState = {
        ...cd[channelName]
      };
      channelState.unreadMessageCount++;
      return {
        ...cd,
        [channelName]: channelState
      };
    });
  };
  useEffect(() => {
    const token = Cookies.get('tw');
    if (token) {
      const client = new Client(token);
      client.on('connectionStateChanged', state => {
        if (state === 'connected') {
          setTwilioClient(client);
        }
      });
    }
  }, []);
  const handleMessageAdded = (message, channelId, channelName) => {
    if (verifyIfChatIsOpen(channelId)) {
      setChannelData(channelName, 'unreadMessageCount', 0);
    }
    const isAuthorAdmin = message.author === TWILIO_ADMIN_IDENTITY;
    const isAuthorCurrentUser = message.author === String(user.id);
    if (!(isAuthorAdmin && user.is_administrator) && !isAuthorCurrentUser) {
      incrementUnreadMessageCount(channelName);
    }
  };
  useEffect(() => {
    if (!twilioClient) return;
    return () => {
      Object.keys(conversationData).forEach(item => {
        conversationData[item]?.channel?.removeAllListeners();
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [twilioClient]);
  const onClickChatButton = async ({
    channelName,
    channelSid,
    groupMembers,
    popupName,
    userId,
    isAdminPartnerChannel = false
  }) => {
    createChatDetailRegister(channelSid);
    setChannelData(channelName, 'unreadMessageCount', 0);
    onConnect({
      channelSid,
      identity: userId,
      popupName,
      groupMembers,
      isAdminPartnerChannel
    });
  };
  return <Container>
      {user.is_network_partner && project.assignment_chats.filter(ac => ac.partner.id && ac.partner.id === user.id).map(ac => {
      const sid = ac.twilio_conversation_sid;
      const convData = conversationData[sid];
      return <ChatButton chatName="GTI Chat" channelSid={sid} htmlId={`tw-sid-${sid}`} icon={<ProjectIcon />} isInitializationFailed={convData.isInitializationFailed} isLoading={convData.isInitializing} isUserAdmin={user.is_administrator} messageCount={convData.unreadMessageCount} onClick={() => {
        onClickChatButton({
          channelName: sid,
          channelSid: sid,
          popupName: 'GTI',
          userId: ac.partner.id,
          isAdminPartnerChannel: true
        });
      }} />;
    })}
    </Container>;
};
export default AssignmentButton;